var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Icon-/-Search",
    transform: "translate(-3.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "noun_Search_905006"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,10.1129032 C11.4919355,9.02419355 12.0967742,7.62096774 12.0967742,6.0483871 C12.0967742,2.70967742 9.41129032,0 6.09677419,0 C2.78225806,0 0.0967741935,2.70967742 0.0967741935,6 C0.0967741935,9.29032258 2.80645161,12 6.09677419,12 C7.35483871,12 8.54032258,11.5887097 9.45967742,10.9596774 L13.766129,15.266129 C13.9112903,15.4112903 14.0564516,15.4596774 14.2258065,15.4596774 C14.3951613,15.4596774 14.5645161,15.3870968 14.6854839,15.266129 C14.9516129,15 14.9516129,14.5887097 14.6854839,14.3225806 L10.5,10.1129032 Z M6.12096774,10.6693548 C3.55645161,10.6693548 1.4516129,8.56451613 1.4516129,6 C1.4516129,3.43548387 3.55645161,1.33064516 6.12096774,1.33064516 C8.68548387,1.33064516 10.7903226,3.43548387 10.7903226,6 C10.7903226,8.56451613 8.70967742,10.6693548 6.12096774,10.6693548 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/IconSearch.2b836589d76745686921875b542d7ec1.svg";
export { ForwardRef as ReactComponent };